export const properties = [
  {
    id: 1,
    title: "VIVER MAIS PARQUE ECOLOGICO - CONSTRUTORA TENDA S/A",
    type: "apartamento",
    price: 236232,
    location: "Rua Senador Elói de Souza, ERMELINO MATARAZZO, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 45,
    image: "https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20urban%20architecture%20clean%20facade%20daytime%20blue%20sky%20contemporary%20design%20condominium&width=600&height=400&seq=prop-001&orientation=landscape",
    tag: "Novo",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 2,
    title: "ZEN",
    type: "apartamento",
    price: 187000,
    location: "Rua Professor Francisco Pinheiro, Vila Princesa Isabel, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 42,
    image: "https://readdy.ai/api/search-image?query=Contemporary%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20modern%20residential%20condominium%20clean%20lines%20glass%20balconies%20daytime&width=600&height=400&seq=prop-002&orientation=landscape",
    tag: "Oportunidade",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 3,
    title: "VIVAZ VILA PRUDENTE - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 276200,
    location: "Rua Salvador Mastropietro, Vila Santa Clara, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 48,
    image: "https://readdy.ai/api/search-image?query=Modern%20mid-rise%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20residential%20complex%20green%20landscaping%20daytime%20clean%20architecture&width=600&height=400&seq=prop-003&orientation=landscape",
    tag: "Destaque",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 4,
    title: "VIVAZ PARQUE PRIME FREGUESIA DO O - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 267000,
    location: "Rua Rio Verde, Jardim Monjolo, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 47,
    image: "https://readdy.ai/api/search-image?query=New%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20modern%20facade%20white%20walls%20large%20windows%20residential%20condominium%20daytime&width=600&height=400&seq=prop-004&orientation=landscape",
    tag: "Novo",
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 5,
    title: "VIVAZ PARQUE FREGUESIA DO O II - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 197000,
    location: "Rua Rio Verde, Jardim Monjolo, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 40,
    image: "https://readdy.ai/api/search-image?query=Compact%20modern%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20urban%20residential%20architecture%20clean%20design%20daytime%20street%20view&width=600&height=400&seq=prop-005&orientation=landscape",
    tag: "Oportunidade",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 6,
    title: "VIVAZ ERMELINO MATARAZZO - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 188900,
    location: "Avenida Doutor Assis Ribeiro, Jardim Keralux, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 41,
    image: "https://readdy.ai/api/search-image?query=Urban%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20modern%20residential%20condominium%20street%20view%20daytime%20clean%20facade&width=600&height=400&seq=prop-006&orientation=landscape",
    tag: "Novo",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 7,
    title: "VIVA SAO MIGUEL - CONSTRUTORA TENDA S/A",
    type: "apartamento",
    price: 230177,
    location: "Rua Facheiro Preto, VILA PROGRESSO, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 44,
    image: "https://readdy.ai/api/search-image?query=Modern%20affordable%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20residential%20condominium%20clean%20architecture%20daytime%20blue%20sky&width=600&height=400&seq=prop-007&orientation=landscape",
    tag: "Destaque",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 8,
    title: "VIVAZ ESTACAO SACOMA - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 218000,
    location: "Rodovia Anchieta, VILA MOINHO DE VENTO, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 43,
    image: "https://readdy.ai/api/search-image?query=Contemporary%20residential%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20apartment%20complex%20modern%20design%20daytime%20green%20spaces&width=600&height=400&seq=prop-008&orientation=landscape",
    tag: null,
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 9,
    title: "VIVAZ CANTAREIRA 3 - 2 FASE - BL 2-3 - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 268000,
    location: "DO CORREDOR, Jaraguá, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 46,
    image: "https://readdy.ai/api/search-image?query=Modern%20apartment%20condominium%20exterior%20S%C3%A3o%20Paulo%20Brazil%20residential%20building%20clean%20facade%20balconies%20daytime%20urban&width=600&height=400&seq=prop-009&orientation=landscape",
    tag: "Destaque",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 10,
    title: "VIVAZ CANTAREIRA 3 - 1 FASE - BL 1-4-5 - VIVAZ RESIDENCIAL LTDA",
    type: "apartamento",
    price: 217000,
    location: "DO CORREDOR, Jaraguá, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 42,
    image: "https://readdy.ai/api/search-image?query=New%20residential%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20modern%20condominium%20white%20facade%20daytime%20clean%20architecture&width=600&height=400&seq=prop-010&orientation=landscape",
    tag: null,
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 11,
    title: "VIVA PARQUE DO CARMO - FASE 1 - CONSTRUTORA TENDA S/A",
    type: "apartamento",
    price: 225800,
    location: "Rua André de Almeida, Cidade São Mateus, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 44,
    image: "https://readdy.ai/api/search-image?query=Modern%20family%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20residential%20condominium%20daytime%20clean%20lines%20green%20areas&width=600&height=400&seq=prop-011&orientation=landscape",
    tag: "Novo",
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 12,
    title: "VIVA BENX ESTACAO CAMPO BELO - BENX INCORPORADORA",
    type: "apartamento",
    price: 337414,
    location: "Rua Gabriele D'Annunzio, Campo Belo, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 52,
    image: "https://readdy.ai/api/search-image?query=Premium%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20luxury%20residential%20condominium%20modern%20architecture%20daytime%20elegant%20facade&width=600&height=400&seq=prop-012&orientation=landscape",
    tag: "Destaque",
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 13,
    title: "VIVA BENX KLABIN - BENX INCORPORADORA",
    type: "apartamento",
    price: 392905,
    location: "Rua Alberto Day, SANTA CRUZ, São Paulo",
    bedrooms: 3,
    bathrooms: 2,
    area: 65,
    image: "https://readdy.ai/api/search-image?query=Luxury%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20high-end%20residential%20condominium%20modern%20design%20glass%20facade%20daytime&width=600&height=400&seq=prop-013&orientation=landscape",
    tag: "Destaque",
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 14,
    title: "VITTO SANTA CECILIA - ENGELUX COMERCIAL E CONSTRUTORA LTDA",
    type: "apartamento",
    price: 256352,
    location: "Rua Vitorino Carmilo, Campos Elíseos, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 45,
    image: "https://readdy.ai/api/search-image?query=Historic%20district%20modern%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20urban%20residential%20architecture%20daytime%20clean%20design&width=600&height=400&seq=prop-014&orientation=landscape",
    tag: null,
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 15,
    title: "VIVA BENX BUTANTA - BENX INCORPORADORA",
    type: "apartamento",
    price: 356500,
    location: "Rua Desembargador Armando Fairbanks, Butantã, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 55,
    image: "https://readdy.ai/api/search-image?query=Spacious%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20modern%20residential%20condominium%20university%20district%20daytime%20clean%20architecture&width=600&height=400&seq=prop-015&orientation=landscape",
    tag: "Destaque",
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 16,
    title: "VISTA MAGNOLIAS",
    type: "casa",
    price: 14800000,
    location: "Avenida das Magnólias, Cidade Jardim, São Paulo",
    bedrooms: 4,
    bathrooms: 5,
    area: 650,
    image: "https://readdy.ai/api/search-image?query=Luxury%20modern%20house%20exterior%20S%C3%A3o%20Paulo%20Brazil%20large%20garden%20swimming%20pool%20premium%20residential%20architecture%20daytime%20elegant%20design%20cidade%20jardim&width=600&height=400&seq=prop-016&orientation=landscape",
    tag: "Destaque",
    features: ["piscina", "garagem", "area-gourmet"],
    broker: "Daniel Carvalho"
  },
  {
    id: 17,
    title: "VITRINE TATUAPE - LOJAS - DIALOGO ENGENHARIA E CONSTRUCAO LTDA",
    type: "apartamento",
    price: 1775000,
    location: "Rua Guaraciaba, Chácara Califórnia, São Paulo",
    bedrooms: 0,
    bathrooms: 1,
    area: 120,
    image: "https://readdy.ai/api/search-image?query=Modern%20loft%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20commercial%20residential%20mixed%20use%20contemporary%20architecture%20daytime%20urban&width=600&height=400&seq=prop-017&orientation=landscape",
    tag: null,
    features: [],
    broker: "Daniel Carvalho"
  },
  {
    id: 18,
    title: "VISTA CERET",
    type: "apartamento",
    price: 389332,
    location: "Avenida Doutor Eduardo Cotching, Jardim Analia Franco, São Paulo",
    bedrooms: 2,
    bathrooms: 1,
    area: 58,
    image: "https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20exterior%20S%C3%A3o%20Paulo%20Brazil%20upscale%20residential%20condominium%20clean%20facade%20daytime%20blue%20sky%20architecture&width=600&height=400&seq=prop-018&orientation=landscape",
    tag: "Novo",
    features: ["garagem"],
    broker: "Daniel Carvalho"
  },
  {
    id: 19,
    title: "VILLA SERENA",
    type: "casa",
    price: 16500000,
    location: "Avenida Doutor Alberto Penteado, Cidade Jardim, São Paulo",
    bedrooms: 3,
    bathrooms: 4,
    area: 580,
    image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20house%20exterior%20S%C3%A3o%20Paulo%20Brazil%20premium%20residential%20property%20large%20garden%20modern%20architecture%20daytime%20sophisticated%20design&width=600&height=400&seq=prop-019&orientation=landscape",
    tag: "Destaque",
    features: ["piscina", "garagem", "area-gourmet"],
    broker: "Daniel Carvalho"
  }
];

export const propertyTypes = [
  { value: "apartamento", label: "Apartamento", icon: "ri-building-line" },
  { value: "casa", label: "Casa", icon: "ri-home-line" },
  { value: "cobertura", label: "Cobertura", icon: "ri-building-2-line" },
  { value: "studio", label: "Studio", icon: "ri-hotel-line" },
  { value: "terreno", label: "Terreno", icon: "ri-landscape-line" }
];

export const featuresList = [
  { value: "piscina", label: "Piscina" },
  { value: "garagem", label: "Garagem" },
  { value: "varanda", label: "Varanda" },
  { value: "churrasqueira", label: "Churrasqueira" },
  { value: "area-gourmet", label: "Área Gourmet" }
];

export const locations = [
  "São Paulo - SP",
  "Barueri - SP",
  "Cotia - SP",
  "Santana de Parnaíba - SP",
  "Ibiúna - SP"
];